import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';


export const bagPdfSlice = createApi({
  reducerPath: 'bagPdfSlice',  
  baseQuery: fetchBaseQuery({ baseUrl: `${process.env.REACT_APP_BASE_URL}` }), 
  endpoints: (builder) => ({
    uploadPDF: builder.mutation({
      query: (formData) => ({
        url: '/dagagems/sharebagdata', 
        method: 'POST',
        body: formData,
        headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
          }, 
      }),
    }),
  }),
});


export const { useUploadPDFMutation } = bagPdfSlice;
